module.exports = __webpack_public_path__ + "img/PVP_TechScoutHPRegen1_ua.88eaa440.webp";